<template>
    <div>
        <v-dialog v-model="show_dialog" max-width="1300px" @close="closeDialog" persistent>
            <v-card elevation="0">
                <v-card-title class="headline">{{ $t('action.new') }}</v-card-title>
                <v-card-text>
                    <v-form name="sites">
                        <v-row>
                            <v-col cols="7">
                                <!-- Type d'action -->
                                <v-select
                                    id="action.type"
                                    v-model="action.type_id"
                                    v-validate="'required'"
                                    :items="this.types"
                                    :label="$t('action.type')"
                                    data-vv-name="states"
                                    item-text="name"
                                    item-value="id"
                                    name="action.type"
                                    prepend-icon="mdi-tag-text"
                                    required
                                    :disabled="updating"
                                >
                                    <template slot="item" slot-scope="data">
                                        {{ data.item.name }} : {{ data.item.description }}
                                    </template>

                                    <template slot="selection" slot-scope="data">
                                        {{ data.item.name }} : {{ data.item.description }}
                                    </template>
                                </v-select>

                                <!-- SILOS -->
                                <v-select
                                    id="action.silo"
                                    v-model="action.silo_id"
                                    v-validate="'required'"
                                    :items="site.silos"
                                    :label="$t('action.silo')"
                                    chips
                                    clearable
                                    data-vv-name="states"
                                    item-text="code"
                                    item-value="id"
                                    name="action.silo"
                                    prepend-icon="mdi-silo"
                                    :disabled="updating"
                                >
                                </v-select>

                                <!-- Détail-->
                                <v-textarea
                                    v-model="action.details"
                                    :label="$t('action.details')"
                                    name="input-7-4"
                                    outlined
                                    prepend-icon="mdi-comment-text-multiple-outline"
                                    rows="5"
                                    :disabled="updating"
                                ></v-textarea>

                                <div class="font-weight-bold text-uppercase ">{{ $t('action.add_photos') }}</div>

                                <!-- Message warning sur la taille des photos -->
                                <div class="mt-5 text-red">
                                    {{ $t('action.photo_limitation_rules') }}
                                </div>

                                <v-row>
                                    <v-col cols="12">
                                        <!-- Ajout depuis le PC -->
                                        <v-btn color="primary" @click="openPcPhotoPicker" :disabled="updating">
                                            {{ $t('action.add_from_computer') }}
                                        </v-btn>
                                        <!-- Ajout depuis sandra -->
                                        <v-btn color="primary ml-4" @click="openSandraPhotoPicker" :disabled="updating">
                                            {{ $t('action.add_from_sandra') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <!-- Photos importées par le PC -->
                                <div class="font-weight-bold text-uppercase mt-5">
                                    {{ $t('action.photo_imported_from_computer') }}
                                </div>

                                <!-- Sélecteur de fichier caché -->
                                <v-file-input
                                    v-model="pc_photos"
                                    ref="fileInput"
                                    style="display: none"
                                    accept="image/*"
                                    multiple
                                    @change="handleFileSelect"
                                />

                                <v-row v-if="formatted_pc_photos.length > 0"  >
                                    <v-col cols="4" v-for="(photo, index) in formatted_pc_photos" :key="index">
                                        <v-img :src="photo.url" height="150px" width="400px"/>
                                        <div>{{ photo.name }}</div>
                                        <div>
                                            <span>({{ photo.size }} ko)</span>
                                            <v-icon color="primary" class="cursor-pointer" @click="removeFileFromPc(index)">
                                                mdi-trash-can
                                            </v-icon>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row v-else>
                                    <v-col class="text-caption">
                                        {{ $t('action.empty') }}
                                    </v-col>
                                 </v-row>

                                <!-- Photos importées par Sandra -->
                                <div class="font-weight-bold text-uppercase mt-5">
                                    {{ $t('action.photo_retrieved_from_sandra') }}
                                </div>

                                <v-row v-if="selected_sandra_photos.length > 0"  >
                                    <v-col cols="4" v-for="(photo, index) in selected_sandra_photos" :key="index">
                                        <v-img :src="photo.url" height="150px" width="400px"/>
                                        <div>{{ photo.file_name }}</div>
                                        <div>
                                            <span>({{ photo.size }} ko)</span>
                                            <v-icon color="primary" class="cursor-pointer" @click="removeFileFromSandra(index)">
                                                mdi-trash-can
                                            </v-icon>
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row v-else>
                                    <v-col class="text-caption">
                                        {{ $t('action.empty') }}
                                    </v-col>
                                </v-row>

                            </v-col>

                            <v-col cols="5">
                                <v-switch
                                    v-model="action.notification_sent"
                                    :label="$t('action.notify')"
                                    class="ma-2"
                                    :disabled="updating"
                                />

                                <div v-if="action.notification_sent">
                                    <v-checkbox
                                        v-if="sales_representative_email"
                                        v-model="emails_to_notify"
                                        :value="sales_representative_email"
                                        :disabled="updating"
                                    >
                                        <template slot="label">
                                            <span class="font-weight-bold role">Commercial :&nbsp;</span>
                                            <span class="role">{{ sales_representative_email }} </span>
                                        </template>
                                    </v-checkbox>
                                    <span v-for="email in emails">
                                <span class="font-weight-bold role">{{ email.name }}</span>

                                <v-checkbox
                                    v-if="email.logistic_manager_email"
                                    v-model="emails_to_notify"
                                    :value="email.logistic_manager_email"
                                    :disabled="updating"
                                    class="mt-0"
                                >
                                    <template slot="label">
                                        <span class="font-weight-bold role">Responsable logistique :&nbsp;</span>
                                        <span class="role">{{ email.logistic_manager_email }}</span>
                                    </template>
                                </v-checkbox>
                                <v-checkbox
                                    v-if="email.quality_safety_manager_email"
                                    v-model="emails_to_notify"
                                    :value="email.quality_safety_manager_email"
                                    :disabled="updating"
                                    class="mt-0"
                                >
                                    <template slot="label">
                                        <span class="font-weight-bold role">Responsable qualité/sécurité :&nbsp;</span>
                                        <span class="role">{{ email.quality_safety_manager_email }}</span>
                                    </template>
                                </v-checkbox>
                                <v-checkbox
                                    v-if="email.sales_manager_email"
                                    v-model="emails_to_notify"
                                    :value="email.sales_manager_email"
                                    :disabled="updating"
                                    class="mt-0"
                                >
                                    <template slot="label">
                                        <span class="font-weight-bold role">{{ $t('repository.sales_manager') }} : </span> &nbsp;
                                        <span class="role"> {{ email.sales_manager_email }}</span>
                                    </template>
                                </v-checkbox>
                                <v-checkbox
                                    v-if="email.sandra_manager_email"
                                    v-model="emails_to_notify"
                                    :value="email.sandra_manager_email"
                                    :disabled="updating"
                                    class="mt-0"
                                >
                                    <template slot="label">
                                        <span class="font-weight-bold role">Référent ZL :&nbsp;</span>
                                        <span class="role">{{ email.sandra_manager_email }}</span>
                                    </template>
                                </v-checkbox>

                            </span>

                                <v-textarea
                                    v-model="additionalMails"
                                    hint="Séparer les mails par un point virgule ( ; )"
                                    label='Adresses mails supplémentaires séparés par des ";"'
                                    outlined
                                    rows="2"
                                >
                                </v-textarea>

                                </div>
                            </v-col>
                        </v-row>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="darken-1" :disabled="updating" text @click="closeDialog">
                                {{ $t('site.cancel') }}
                            </v-btn>
                            <v-btn :disabled="updating" color="warning darken-1"
                                   text @click="addAction()">
                                {{ $t('action.add') }}
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="sandra_dialog" max-width="1200px" @close="resetAction" persistent>
            <v-card elevation="0">
                <v-card-title class="headline">{{ $t('action.pick_photos_from_sandra') }}</v-card-title>
                <v-card-text>

                    <v-data-table
                        :no-data-text="$t('global.no_data')"
                        :loading-text="$t('global.loading_text')"
                        :no-results-text="$t('global.no_results_text')"
                        :headers="sandra_photos_headers"
                        :items="sandra_server_photos"
                        class="elevation-1"
                        :items-per-page="-1"
                        v-model="dialog_selected_sandra_photos"
                        item-key="id"
                        show-select                    >
                        <template v-slot:item.url="{ item }">
                            <v-img :src="item.url" class="ma-2" height="120px" width="200px"/>
                        </template>

                        <template v-slot:item.name="{ item }">
                            {{ nullable(item.file_name)}} ({{ item.size}} ko)
                        </template>

                        <template v-slot:item.silo="{ item }">
                            {{ nullable(item.silo)}}
                        </template>

                        <template v-slot:item.created_at="{ item }">
                            {{ item.created_at | moment('L LT') }}
                        </template>

                        <template v-slot:item.comment="{ item }">
                            {{ nullable(item.comment)}}
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darken-1" text @click="cancelSandraDialog">
                        {{ $t('site.cancel') }}
                    </v-btn>
                    <v-btn color="primary"
                           text @click="addSandraImages()">
                        {{ $t('action.add') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
            v-model="snackbar"
            :color="snackbar_type"
            top
        >
            {{ snackbar_text }}
            <v-btn
                text
                @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import {
    ACTIONS_FORM,
    ACTIONS_PHOTOS,
    ALERT,
    MANUAL_ACTION_TYPES,
    SILO,
    SILOS_IMAGES,
    SITE_UPDATE_REQUESTS
} from "../../api";

export default {
        name: "action-notification-dialog",
        props: {
            show_dialog: {
                type: Boolean,
                required: true,
                default: false
            },
            action_type_code: {
                type: String,
                default: ''
            },
            alert: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                dialog: false,
                snackbar: false,
                snackbar_text: '',
                snackbar_type: null,
                types: [],
                updating: false,
                additionalMails: null,
                selectedType: null,
                emails_to_notify: [],
                action: {
                    site_id: null,
                    type_id: null,
                    details: null,
                    silo_id: null,
                    notification_sent: false,
                    is_manual: true,
                },
                existing_silo: {},
                update_request: {},
                pc_photos: [],
                formatted_pc_photos: [],
                sandra_dialog: false,
                sandra_photos: [],
                sandra_server_photos: [],
                sandra_photos_headers: [
                    {
                        text: this.$t('action.photo'),
                        value: 'url',
                        sortable: false
                    },
                    {
                        text: this.$t('action.name'),
                        value: 'name',
                        sortable: false
                    },
                    {
                        text: this.$t('action.silo'),
                        value: 'silo',
                        sortable: false
                    },
                    {
                        text: this.$t('action.date'),
                        value: 'created_at',
                        sortable: false
                    },
                    {
                        text: this.$t('action.comment'),
                        value: 'comment',
                        sortable: false
                    },
                ],
                selected_sandra_photos: [],
                dialog_selected_sandra_photos: []
            }
        },
        async mounted() {
            await this.initialization()
        },
        methods: {
            async initialization(){
                this.initAction()

                await this.getManualActionTypes();

                if (this.action_type_code) {
                    const action_type = this.types.find(type => type.code === this.action_type_code);
                    this.action.type_id = action_type.id;
                }

                await this.setActionDetails();

                this.handleNotificationSending()
            },
            closeDialog(){
                this.$emit('close-dialog')
                this.resetAction()
            },
            initAction(){
                this.resetAction()
                this.action.site_id = this.site.id;
                this.action.silo_id = this.silo?.id ?? null;
            },
            handleNotificationSending() {
                this.action.notification_sent = true
                this.site.logistic_areas.filter(zl => zl.sales_manager_email !== null)
                    .forEach(zl => this.emails_to_notify.push(zl.sales_manager_email))
            },
            openSandraDialog(){
                this.sandra_dialog = true
            },
            async getSandraSilosImages(){
                this.loading = true;
                let response = await this.axios.get(this.replacePathParams(SILOS_IMAGES,
                    {site: this.site.id}),
                );
                this.sandra_server_photos = response.data
                this.loading = false;
            },
            async openSandraPhotoPicker() {
                await this.getSandraSilosImages()
                this.openSandraDialog()
            },
            openPcPhotoPicker(){
                this.$refs.fileInput.$el.querySelector('input[type="file"]').click();
            },
            handleFileSelect() {
                let photos = this.formatPcPhotos()
                this.formatted_pc_photos = [...photos, ...this.formatted_pc_photos]
            },
            formatPcPhotos(){
                return this.pc_photos.map(image => ({
                    name: image.name ?? '-',
                    size: typeof image.size === 'number' ? Math.floor(image.size / 1000) : '-',
                    url: URL.createObjectURL(image),
                    is_new: true,
                    file: image
                }));
            },
            removeFileFromPc(index){
                this.formatted_pc_photos.splice(index, 1);
            },
            cancelSandraDialog(){
                this.sandra_dialog = false
            },
            nullable(item){
                if(item === null) return '-'
                return item
            },
            addSandraImages(){
                this.selected_sandra_photos = this.dialog_selected_sandra_photos
                this.sandra_dialog = false
            },
            removeFileFromSandra(index){
                this.selected_sandra_photos.splice(index, 1);
                this.dialog_selected_sandra_photos = this.selected_sandra_photos
            },
            formatData(action){
                let data = new FormData();

                if(action.details !== null && typeof action.details !== 'undefined') {
                    data.append("details", action.details)
                }

                if(action.is_manual !== null && typeof action.is_manual !== 'undefined') {
                    data.append("is_manual", action.is_manual)
                }

                if(action.notification_sent !== null && typeof action.notification_sent !== 'undefined') {
                    data.append("notification_sent", action.notification_sent)
                }

                if(action.email_send !== null && typeof action.email_send !== 'undefined') {
                    data.append("email_send", action.email_send)
                }

                if(action.site_id !== null && typeof action.site_id !== 'undefined') {
                    data.append("site_id", action.site_id)
                }

                if(action.silo_id !== null && typeof action.silo_id !== 'undefined') {
                    data.append("silo_id", action.silo_id)
                }

                if(action.type_id !== null && typeof action.type_id !== 'undefined') {
                    data.append("type_id", action.type_id)
                }

                if(this.selected_sandra_photos.length > 0) {
                    data.append("photos_from_sandra", JSON.stringify(this.selected_sandra_photos));
                }

                let images = this.formatted_pc_photos.map(item => {
                    return item.file
                })

                if(images.length > 0){
                    images.forEach(image => {
                        data.append("photos_from_computer[]", image);
                    })
                }

                return data;
            },
            getSiteCoordinates(){
                if (this.site) {
                    let coordinates = this.site.address_1;
                    if (this.site.address_2 !== null) coordinates = coordinates + ' ' + this.site.address_2;
                    if (this.site.address_3 !== null) coordinates = coordinates + ' ' + this.site.address_3;
                    if (this.site.zip !== null) coordinates = coordinates + ' ' + this.site.zip;
                    if (this.site.city !== null) coordinates = coordinates + ', ' + this.site.city;

                    return coordinates;
                }
                return '-';
            },
            getSiteGpsCoordinates(){
                if(this.site && this.site.longitude && this.site.latitude) {
                    return this.site.latitude + ', ' + this.site.longitude;
                }
                return '-';
            },
            getSiteReference(){
                let reference = '';
                let companies = []
                _.each(this.site?.companies, (company) => {
                    companies.push(company.code);
                });

                companies.forEach( (company, key) => {
                    reference = reference + company;
                    if(key + 1 !== companies.length){
                        reference += ', ';
                    }
                })

                return reference;
            },
            getSiteContactName(){
                return this.site?.contact_avril_name ?? this.$t('site.none');
            },
            getSiteContactPhone(){
                return this.site?.contact_avril_telephone ?? this.$t('site.none');
            },
            getAuthenticatedUserMail(){
                return this.$auth.user().email;
            },
            async setActionDetails(){
                this.action.details =
                    this.$t('alert.maj_access_equipment.title') + '\n'

                    +' \n' +

                    this.$t('alert.maj_access_equipment.detail_concerned_site').toUpperCase() + '\n' + '\n' +

                    this.$t('site.reference_breeder_gescom') +' : ' + this.getSiteReference() + '\n' +
                    this.$t('site.site_name') +' : ' + this.site?.name + '\n' +
                    this.$t('site.coordinates') +' : ' + this.getSiteCoordinates() + '\n'+
                    this.$t('site.gps_coordinates') +' : ' + this.getSiteGpsCoordinates() + '\n'+
                    this.$t('site.contact_name') +' : ' + this.getSiteContactName() + '\n'+
                    this.$t('site.phone') +' : ' + this.getSiteContactPhone() + '\n' +

                    '\n' +

                    this.$t('site.detail_of_the_request').toUpperCase() + '\n \n' +

                    this.$t('alert.access') + ' : ' + (this.access && this.access?.name ? this.access.name : 'Non modifié') + '\n' +
                    this.$t('alert.equipment') + ' : ' + (this.equipment && this.equipment?.name ? this.equipment.name : 'Non modifié') + '\n' +
                    this.$t('alert.driver') + ' : ' + (this.driver && this.driver?.name ? this.driver.name : '-') + '\n' +
                    this.$t('alert.truck') + ' : ' + (this.truck?.code ?? '-') + '\n' +

                    '\n' +

                    this.$t('site.sandra_user_approving_the_request') + ' : ' + '\n' + this.getAuthenticatedUserMail();
            },
            mergeMails() {
                const mails = this.additionalMails === null ? [] : this.additionalMails.split(';');
                mails.forEach(mail => this.emails_to_notify.push(mail));
            },
            addAuthUserEmail(){
                let auth_email = this.getAuthenticatedUserMail()
                if (!this.emails_to_notify.includes(auth_email)) {
                    this.emails_to_notify.push(auth_email)
                }
            },
            resetSnackbar() {
                this.snackbar_type = null;
                this.snackbar_text = null;
                this.snackbar = false;
            },
            showSnackbar(type, text) {
                this.snackbar_type = type;
                this.snackbar_text = text;
                this.snackbar = true;
            },
            async getManualActionTypes() {
                try {
                    let {data} =  await this.axios.get(MANUAL_ACTION_TYPES)
                    this.types = data
                }catch (e) {
                    this.showSnackbar('error', this.$t('global.error'));
                }
            },
            addAction() {
                this.updating = true;

                if (this.action.notification_sent) {
                    this.mergeMails()
                    //this.addAuthUserEmail()
                    this.action.email_send = _.join(this.emails_to_notify, ';');
                }

                let data = this.formatData(this.action)

                this.axios.post(ACTIONS_FORM, data).then(() => {
                    if (this.alert && this.alert.id) {
                        this.axios.delete(this.replacePathParams(ALERT, {alert: this.alert?.id}))
                        this.$emit('reload-alerts')
                    }
                    this.$emit('action-created-succeeded');
                }).catch(() => {
                    this.$emit('action-created-failed');
                }).finally(() => {
                    this.updating = false;
                    this.closeDialog()
                });
            },
            resetAction() {
                this.action.details = null
                this.action.type_id = null
                this.action.silo_id = null
                this.action.notification_sent = false
                this.action.is_manual = true
                this.additionalMails = null
                this.dialog_selected_sandra_photos = []
                this.selected_sandra_photos = []
                this.formatted_pc_photos = []
                this.setDefaultEmailsToNotify()
            },
            setDefaultEmailsToNotify() {
                this.emails.forEach(email => {
                    if (email.quality_safety_manager_email) {
                        this.emails_to_notify.push(email.quality_safety_manager_email);
                    }
                    if (email.logistic_manager_email) {
                        this.emails_to_notify.push(email.logistic_manager_email);
                    }
                    if (email.sandra_manager_email) {
                        this.emails_to_notify.push(email.sandra_manager_email);
                    }
                    if (email.sales_manager_email) {
                        this.emails_to_notify.push(email.sales_manager_email);
                    }
                });
            },
            setDefaultSalesEmailsToNotify() {
                if (this.sales_representative_email) {
                    this.emails_to_notify.push(this.sales_representative_email);
                }
            },
        },
        computed: {
            site() {
                return this.alert?.alertable?.site
            },
            silo() {
                return this.alert?.alertable?.silo
            },
            access() {
                return this.alert?.alertable?.access
            },
            equipment() {
                return this.alert?.alertable?.equipment
            },
            truck() {
                return this.alert?.alertable?.truck
            },
            driver() {
                return this.alert?.alertable?.driver
            },
            sales_representative_email() {
                let sales = null;
                if (this.action.silo_id) {
                    sales = this.site.silos.find(silo => silo.id === this.action.silo_id).sales_representative_email;
                }

                return sales;
            },
            emails() {
                if (!Array.isArray(this.site?.logistic_areas)) return [];

                return this.site.logistic_areas
                    .map(area => {
                        const {
                            name,
                            logistic_manager_email,
                            quality_safety_manager_email,
                            sandra_manager_email,
                            sales_manager_email
                        } = area;

                        const emailObject = {
                            name,
                            ...(logistic_manager_email && { logistic_manager_email }),
                            ...(quality_safety_manager_email && { quality_safety_manager_email }),
                            ...(sandra_manager_email && { sandra_manager_email }),
                            ...(sales_manager_email && { sales_manager_email })
                        };

                        return Object.keys(emailObject).length > 1 ? emailObject : null;
                    })
                    .filter(Boolean);
            }

        },
        watch: {
            emails: {
                handler: "setDefaultEmailsToNotify",
                immediate: true,
            },
            sales_representative_email: {
                handler: "setDefaultSalesEmailsToNotify",
                immediate: true,
            },
        }
    }
</script>

<style scoped lang="scss">

.text-red{
    color: #c23a3a
}

.cursor-pointer{
    cursor: pointer;
}

.role{
    font-size: 14px;
}

</style>
